
  import {Component, Vue, Watch} from "vue-property-decorator"

  import InputText from "primevue/inputtext"
  import Button from "primevue/button"

  Vue.component("InputText", InputText)
  Vue.component("Button", Button)

  import user_module from "@/modules/user"

  @Component
  export default class Login extends Vue {
    public login: any = ''
    public password: any = ''

    async created() {
      this.login = user_module.userInfo.Login
      console.log(">>>>>>> created ---> this.login", this.login)
    }

    async signIn() {
      this.$store.commit("setLoader", true)
      try {
        console.log(">>>>>>> Login page ---> login: ", this.login, " , password: ", this.password)
        const response = await user_module.getLogin({login: this.login, password: this.password})

        // this.$toast.add({
        //   severity: 'success',
        //   summary: 'Successfuly Authorization',
        //   detail: `Hi, ${response.data.FName} ${response.data.LName}`,
        //   life: 3000
        // });

        //@ts-ignore
        // this.lexe.authorization()
        this.$router.push('/home')
        this.$store.commit("setLoader", false)
        // window.location.assign('/crm/leads')
      } catch (err) {

        console.error('FAILED TO LOGIN', err)
        this.$store.commit("setLoader", false)
        // this.$toast.add({
        //   severity: 'error',
        //   summary: 'Failed Authorization',
        //   detail: err,
        //   life: 4000
        // });
      }
    }
  }
